import {
	defaultColDefination,
	getColumnDefFragmentation,
	initialGridData,
} from 'CategoryManagement/Explore/DetailedAnalysis/utils';
import { CategoryInsightsSettingsContext } from 'contexts/CategoryInsightsSettingsContext';
import { CategoryManagementContext } from 'contexts/CategoryManagementContext';
import React, {
	createContext,
	useContext,
	useState,
	useEffect,
	useMemo,
} from 'react';
import { getWellManagedCategories } from 'utils/apiRequests';
import { formatNumber, formatSpendWithDecimalAndSymbol } from 'utils/number';
import { getHeaderByTaxonomyType } from '../../CategoryManagement/utils';

const WellManagedCategoriesContext = createContext();

const categoriesText = 'categories';

export const WellManagedCategoriesProvider = ({
	children,
	currencySymbol,
	hideDecimals,
}) => {
	const [isLoading, setIsLoading] = useState(false);
	const [analysis, setAnalysis] = useState(`X ${categoriesText}`);
	const [gridData, setGridData] = useState(initialGridData);
	const {
		currentSelectCategory,
		dateRangeData,
		isFetching,
		isDirect,
		isSourceable,
		taxonomyType,
	} = useContext(CategoryManagementContext);
	const { loading: isSettingsFetching, isSaving, vendorCountMin } = useContext(
		CategoryInsightsSettingsContext
	);
	const { categoryName } = currentSelectCategory;
	const { dateFrom, dateTo } = dateRangeData;

	const taxonomyHeader = useMemo(() => getHeaderByTaxonomyType(taxonomyType), [
		taxonomyType,
	]);

	useEffect(
		() => {
			if (!isSaving && !isSettingsFetching && !isFetching) {
				setIsLoading(true);
				if (
					categoryName !== '' ||
					categoryName !== null ||
					categoryName !== undefined
				) {
					const payLoad = {
						categoryName: categoryName,
						dateFrom: dateFrom,
						dateTo: dateTo,
						isSourceable: isSourceable,
						aptaxonomy: isDirect,
						taxonomyType: taxonomyType,
					};
					getWellManagedCategories(payLoad)
						.then(response => {
							if (response.succeeded) {
								if (response.data === null) {
									setAnalysis(`No ${categoriesText}.`);
									setIsLoading(false);
									setGridData(initialGridData);
								} else {
									if (response.data.length > 0 || response.data !== null) {
										if (!!Object.keys(response.data).length) {
											const analysisString = `${formatNumber(
												response.data.wellManagedCategories
											)} ${categoriesText}`;
											setAnalysis(analysisString);
											setIsLoading(false);
										}
									}
									const categoryLevel = categoryName.split('/').length - 2;
									if (response.data.explore.length > 0) {
										const filteredData = response.data.explore
											.filter(el => el.vendorCount <= vendorCountMin)
											.map(x => {
												return {
													...x,
													totalSpend: formatSpendWithDecimalAndSymbol(
														x?.totalSpend,
														currencySymbol,
														hideDecimals,
														2
													).toUpperCase(),
												};
											});
										const colResult = getColumnDefFragmentation(
											categoryLevel,
											taxonomyHeader
										);
										setGridData(prevState => ({
											...prevState,
											rowData: filteredData,
											columnDefs: colResult,
											defaultColDef: defaultColDefination,
										}));
									}
								}
							} else {
								setIsLoading(false);
							}
						})
						.catch(() => setIsLoading(false));
				} else {
					setIsLoading(false);
				}
			}
		}, // eslint-disable-next-line
		[
			isSaving,
			dateRangeData,
			categoryName,
			isSettingsFetching,
			isFetching,
			isDirect,
			isSourceable,
			taxonomyType,
		]
	);

	return (
		<WellManagedCategoriesContext.Provider
			value={{ isLoading, analysis, gridData }}
		>
			{children}
		</WellManagedCategoriesContext.Provider>
	);
};

export const useWellManagedCategoriesContext = () => {
	return useContext(WellManagedCategoriesContext);
};
